import React, { useState } from 'react';
import './index.scss';
import { TimeBar } from '@/components/bar';
import { BasicLayout, LineLayout, EasyGridLayout } from '@/layout'
import { Card } from '@/components/card';
import { DigitalBlock } from '@/components/digitalBlock';
import { Icon } from '@/components/icon';
import { Circle } from '@/components/circle';
import * as Charts from '@/components/charts';
import { searchParams, handleDataForLineChart } from '@/utils';
import { getTimeRangeByUrl } from '@/utils/time';
import { useRequest } from 'ahooks';
import * as API from '@/api/request';
import Loading from '@/components/loading/loading';
import { Error } from '@/components/error';
import { ExportButton } from '@/components/exportButton';
import FormatterType from '@/components/charts/formatterType';
const lineCode = searchParams().lineCode || null;
const handleDataForBarChart = (data: Array<any>) => {
    return {
        xAxis: data.map(item => item.defectName),
        yAxis: data.map(item => item.count)
    }
}

const Quality = () => {
    const [timeRange, setTimeRange] = useState(getTimeRangeByUrl())
    let { data, loading, error } = useRequest(() => {
        return Promise.all([
            API.Quality.getStatisticValues(lineCode, timeRange),
            API.Quality.getFirstPassYieldByTimeRange(lineCode, timeRange),
            API.Quality.getNotGoodCountByTimeRange(lineCode, timeRange),
            API.Quality.getNotGoodCountByDefectTypes(lineCode, timeRange)
        ])
    }, { refreshDeps: [timeRange] })
    if (loading) {
        return <BasicLayout name='质量管理'>
            <TimeBar change={(timeRange: any) => { setTimeRange(timeRange) }} size={0.85} height={35} />
            <Loading />
        </BasicLayout>
    }
    if (error) {
        return <BasicLayout name='质量管理'>
            <TimeBar change={(timeRange: any) => { setTimeRange(timeRange) }} size={0.85} height={35} />
            <Error size={0.5} />
        </BasicLayout>
    }

    const [staticValue, firstPassYield, notGoodCount, notGoodCountByDefectTypes]: any = data;


    return (
        <BasicLayout name='质量管理'>
            <TimeBar change={(timeRange: any) => { setTimeRange(timeRange) }} size={0.85} height={35} />
            <Card customBar={<React.Fragment />} >
                <LineLayout justify='start' padding={[0, 0, 0, 10]} height={70} gap={10}>
                    <Circle>
                        <Icon iconName='direct.png' size={1.2} />
                    </Circle>
                    <DigitalBlock value={staticValue.firstPassYield * 100} name='直通率' unit='%' size={0.85} spacing={150} retentionDigit={1} />
                </LineLayout>
            </Card>
            <EasyGridLayout width={355} height={85} rows={1} columns={2} padding={[10, 0, 0, 0]} center gap={10}>
                <Card customBar={<React.Fragment />} >
                    <LineLayout justify='start' padding={[0, 0, 0, 10]} height={80} gap={10}>
                        <Circle>
                            <Icon iconName='goodProduct.png' size={1.2} />
                        </Circle>
                        <DigitalBlock type='valueStacking' value={staticValue.okCount + staticValue.notGoodCount} name='检测次数' unit='次' size={0.85} spacing={10} />
                    </LineLayout>
                </Card>
                <Card customBar={<React.Fragment />} >
                    <LineLayout justify='start' padding={[0, 0, 0, 10]} height={80} gap={10}>
                        <Circle>
                            <Icon iconName='badProduct.png' size={1.2} />
                        </Circle>
                        <DigitalBlock type='valueStacking' value={staticValue.notGoodCount} name='缺陷次数' unit='次' size={0.85} spacing={10} />
                    </LineLayout>
                </Card>
            </EasyGridLayout>
            <LineLayout justify='around' padding={[15, 0, 15, 0]} gap={10} direction='column'>
                <Card title='直通率(%)' icon='line.png'>
                    <Charts.BasicLineChart width={355} height={200}
                        dataX={handleDataForLineChart((timeRange as any).timeRangeType, firstPassYield).xAxis}
                        dataY={handleDataForLineChart((timeRange as any).timeRangeType, firstPassYield).yAxis.map(item => item * 100)}
                        formatter={timeRange.timeRangeType === 0 ? FormatterType.TodayMoment : null}
                    />
                </Card>
                <Card title='缺陷次数(次)' icon='line.png'>
                    <Charts.BasicLineChart width={355} height={200}
                        dataX={handleDataForLineChart((timeRange as any).timeRangeType, notGoodCount).xAxis}
                        dataY={handleDataForLineChart((timeRange as any).timeRangeType, notGoodCount).yAxis}
                        formatter={timeRange.timeRangeType === 0 ? FormatterType.TodayMoment : null}
                    />
                </Card>
                <Card title='缺陷类型(次)' icon='bar.png'>
                    <Charts.BarChart width={355} height={200} isShow
                        dataX={handleDataForBarChart(notGoodCountByDefectTypes).xAxis}
                        dataY={handleDataForBarChart(notGoodCountByDefectTypes).yAxis}
                    />
                </Card>
            </LineLayout>
            <ExportButton api='/Export/ExportQualityReport' title='质量报表' />

        </BasicLayout>
    )
}

export { Quality }